import React from 'react';
import PropTypes from 'prop-types';

import {browserHistory} from 'react-router';
import {connect} from 'react-redux';
import {completePasswordRecovery} from '../../../ducks/auth';
import asSubmissionError from '../../../utils/asSubmissionError';

import Modal from '../../../components/modals/Modal';
import ResetPasswordForm from '../../../components/auth/ResetPasswordForm';
import withChannelFormatters from '../../channelUtils/withChannelFormatters';

@withChannelFormatters
@connect()
export default class ResetPasswordModal extends React.PureComponent {
  static modalName = 'resetPassword';

  resetPassword = ({userId, token, password}) => this.props.dispatch(completePasswordRecovery(userId, token, password))
    .catch(asSubmissionError)
    .then(() => browserHistory.push(this.props.channelFormatters.link('/profile')));

  render() {
    const {page, userId, token, ...rest} = this.props;

    return (
      <Modal {...rest} type={page && 'page'}>
        <div className="modal__column">
          <div className="modal__header">Password recovery</div>

          <ResetPasswordForm
            initialValues={{userId, token}}
            onSubmit={this.resetPassword}
          />
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/auth/modals/ResetPasswordModal.js